<template lang="pug">
  svg.svg-logo(:x="x" :y="y" :width="width" :height="height" viewBox="0 0 550 240" preserveAspectRatio="xMidYMid meet")
    title BakingForge
    // Stand Mixer
    g(v-if="!small")
      path.logo-cls-1#sm-body(d="M540.45,116.45H437V39h84.08a19.24,19.24,0,0,0,0-38.47H414a19.21,19.21,0,0,0-4.73,37.8l-10.13,78.15h-4.52a7.42,7.42,0,0,0,0,14.83H540.45a7.42,7.42,0,0,0,0-14.83Z")
      rect.logo-cls-2#attachment-track(x="467.55" y="35.12" width="49.69" height="7.69" rx="3.85")
      path.logo-cls-3#bowl(d="M529,64.24a1.08,1.08,0,0,1,1.06,1s0,.19,0,.79c0,26.63-18.83,48.22-42.05,48.22S446,92.66,446,66c0-.6,0-.79,0-.79a1.09,1.09,0,0,1,1.07-1Z")
      rect.logo-cls-0#switch-track(x="414.04" y="12.04" width="38.22" height="3.85" rx="0.49")
      ellipse.logo-cls-4#switch(cx="431.24" cy="13.96" rx="5.73" ry="5.77")
      path.logo-cls-4#dough-hook(d="M517.26,53.8c-3.82-2.62-10.09,1.13-11.9-1.6-1.05-1.57.47-3.66-.79-4.79a1.88,1.88,0,0,0-.51-.31s0-.07,0-.1V41.91A1.09,1.09,0,0,0,503,40.82h-.73a1.09,1.09,0,0,0-1.08,1.09V47a1.64,1.64,0,0,0,0,.23,3.69,3.69,0,0,0-1.4,1c-1.56,1.91-.49,5.84,1.59,8,4.11,4.23,10.7-.05,13.49,3.19,3.73,4.33-2.54,18.29-7.93,18.37-3.21,0-5.9-4.81-7.15-4-.66.43-.38,2.13,0,3.19,1.26,3.45,5.77,6,9.53,5.59,7.72-.93,10.19-14.47,10.31-15.17C520,65.45,521.47,56.69,517.26,53.8Z")

      // Bowl Contents
      g
        path.logo-cls-7(d="M500.68,84.08c-10.75-9.61-17.6-5.65-30,1.43-12.8,7.32-14.43,10-14.43,10a1.75,1.75,0,0,0,0,1.69s10.83,16.76,32.52,16.9c19.72.13,31.3-17,31.3-17a.82.82,0,0,0-.35-1.24S507.86,90.5,500.68,84.08Z")
        ellipse.logo-cls-7(cx="487.82" cy="68.91" rx="1.08" ry="1.09")
        ellipse.logo-cls-7(cx="489.98" cy="74.71" rx="1.08" ry="1.09")
        ellipse.logo-cls-7(cx="485.66" cy="73.26" rx="1.08" ry="1.09")

    // Anvil
    g#anvil(:transform="anvilTransform")
      path.logo-cls-5(d="M153.54,176.77c0-20,32.52-42.9,62-42.9.88,0,1.76,0,2.63,0l.48-25.11H68.06v9.64H62.79V124H.61c4.8,24.2,23.88,43,67.45,43.12v0c20.1.5,36.15,11.46,36.15,24.92,0,10.52-9.81,19.51-23.7,23.18v13.56H181.07V215.18C161.81,209.73,153.54,191.79,153.54,176.77Z")
      rect.logo-cls-6(x="68.06" y="112.43" width="150.6" height="6.02")

    // Text
    g
      text.logo-text#baking(:transform="bakingTextTransform") {{ bakingText }}
      text.logo-text#forge(:transform="forgeTextTransform") {{ forgeText }}
</template>

<script>
export default {
  name: 'svg-logo',

  props: {
    x: Number,
    y: Number,
    width: {
      type: Number,
      default: 550,
    },
    height: {
      type: Number,
      default: 240,
    },
    small: Boolean,
  },

  computed: {
    anvilTransform() {
      return this.small ? 'translate(0 -100) scale(1.5)' : '';
    },

    bakingText() {
      return this.small ? 'B' : 'Baking';
    },

    bakingTextTransform() {
      return this.small ? 'translate(145 175)' : 'translate(0 95)';
    },

    forgeText() {
      return this.small ? 'F' : 'Forge';
    },

    forgeTextTransform() {
      return this.small ? 'translate(165 230)' : 'translate(230 210)';
    },
  },

};
</script>

<style lang="scss" scoped>
.svg-logo {

  #anvil,#baking,#forge {
    transition: all 0.5s;
  }

  .logo-text {
    fill: #ddd;
    stroke: #000;
    stroke-width: 2px;
    font-size: 125px;
    font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;

    -webkit-touch-callout: none; /* iOS Safari */
      -webkit-user-select: none; /* Safari */
       -khtml-user-select: none; /* Konqueror HTML */
         -moz-user-select: none; /* Firefox */
          -ms-user-select: none; /* Internet Explorer/Edge */
              user-select: none;
  }

  .logo-cls-1 {
    fill: var(--fill-color-1, #00663e);
    stroke: var(--stroke-color-1, #000);
    stroke-width: var(--stroke-width-1, 1px);
    stroke-miterlimit: 10;
  }
  .logo-cls-2 {
    fill: var(--fill-color-2, #999);
    stroke: var(--stroke-color-2, #000);
    stroke-width: var(--stroke-width-2, 0.5px);
    stroke-miterlimit: 10;
  }
  .logo-cls-3 {
    fill: var(--fill-color-3, #CCC);
    stroke: var(--stroke-color-3, #000);
    stroke-width: var(--stroke-width-3, 1px);
    stroke-miterlimit: 10;
  }
  .logo-cls-4 {
    fill: var(--fill-color-4, #F2F2F2);
    stroke: var(--stroke-color-4, #000);
    stroke-width: var(--stroke-width-4, 0.75px);
    stroke-miterlimit: 10;
  }
  .logo-cls-5 {
    fill: var(--fill-color-5, #333333);
    stroke: var(--stroke-color-5, #000);
    stroke-width: var(--stroke-width-5, 1px);
    stroke-miterlimit: 10;
  }
  .logo-cls-6 {
    fill: var(--fill-color-6, #4D4D4D);
    stroke: var(--stroke-color-6, none);
    stroke-width: var(--stroke-width-6, 0px);
    stroke-miterlimit: 4;
  }
  .logo-cls-7 {
    fill: var(--fill-color-7, #FFFFFF);
    stroke: var(--stroke-color-7, #000);
    stroke-width: var(--stroke-width-7, 0.5px);
    stroke-miterlimit: 4;
  }

}
</style>
